module.exports = __webpack_public_path__ + "img/banner-mandala.e4ea095a.png";